(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quick-drawer"] && !Shopify.designMode) return;
  try {
    class QuickViewTrigger extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      // Carousels can move a trigger in the DOM, which runs connectedCallback again. Bind the listeners once.
      if (this.bound) return;
      this.bound = true;
      // The trigger is a custom element, so give it button semantics for keyboard and screen reader users.
      if (!this.hasAttribute('role')) this.setAttribute('role', 'button');
      if (!this.hasAttribute('tabindex')) this.tabIndex = 0;
      if (!this.hasAttribute('aria-label')) {
        this.setAttribute('aria-label', document.querySelector('#quick-view-drawer .quick-view-drawer__title')?.textContent.trim() || 'Quick View');
      }
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        this.click();
      });
      this.addEventListener('click', () => {
        this.dispatchEvent(
          new CustomEvent('open-quick-view', {
            detail: { productUrl: this.dataset.productUrl },
            bubbles: true,
            composed: true,
          })
        );
      });
    }
  }

  customElements.define('quick-view-trigger', QuickViewTrigger);

  class QuickViewDrawer extends HTMLElement {
    constructor() {
      super();
      this.querySelector('button.action-close-quick-view').addEventListener(
        'click',
        this.closeQuickViewDrawer.bind(this)
      );
      this.querySelector('.quick-view-drawer__backdrop').addEventListener(
        'click',
        this.closeQuickViewDrawer.bind(this)
      );
    }
    connectedCallback() {
      // Keyboard support while the drawer is open. The listeners sit on the document, because replacing the drawer
      // content can leave focus on the page body. The size guide inside the drawer handles its own Escape and Tab.
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab' || !this.classList.contains('open') || this.querySelector('modal-dialog[open]')) return;
        const focusable = this.keyboardFocusableElements();
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (!this.contains(document.activeElement)) {
          event.preventDefault();
          (event.shiftKey ? last : first).focus();
        } else if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
      document.addEventListener('keyup', (event) => {
        if (event.key !== 'Escape' || !this.classList.contains('open')) return;
        if (event.target.closest?.('modal-dialog') || this.querySelector('modal-dialog[open]')) return;
        this.closeQuickViewDrawer();
      });
      window.addEventListener('open-quick-view', (event) => {
        if (event.detail.productUrl) {
          this.openQuickViewDrawer(event.detail.productUrl);
        }
      });
    }
    keyboardFocusableElements() {
      const isVisible = (element) =>
        element.checkVisibility
          ? element.checkVisibility({ visibilityProperty: true, opacityProperty: true })
          : element.getClientRects().length > 0;
      // Only one radio per group is a Tab stop: the checked one, or the first enabled one when none is checked.
      const isTabStop = (element) => {
        if (element.type !== 'radio') return true;
        const group = [...this.querySelectorAll('input[type="radio"]')].filter((radio) => radio.name === element.name && !radio.disabled);
        return element.checked || (!group.some((radio) => radio.checked) && group[0] === element);
      };
      return [...this.querySelectorAll('.quick-view-drawer__container :is(a[href], button, input, select, textarea, [tabindex]):not([tabindex="-1"]):not([disabled])')]
        .filter((element) => isVisible(element) && !element.closest('[hidden], [inert], modal-dialog:not([open])') && isTabStop(element));
    }
    buildProductViewUrl(productUrlRaw, view) {
      const productUrl = new URL(productUrlRaw || '/', window.location.origin);
      const params = new URLSearchParams();
      const variantId = productUrl.searchParams.get('variant');

      if (variantId) {
        params.set('variant', variantId);
      }

      params.set('view', view);

      return `${productUrl.pathname}?${params.toString()}`;
    }
    // THis method performs the minimal update, so it switches the info block and the active related product, instead of loading all the related products again
    updateActiveRelatedProduct(nextUrlWithparams, rememberedSelections = {}) {
      const contentDiv = this.querySelector('.quick-view-drawer__content');
      // Increment request seq to prevent race conditions when switching quickly
      this._seq = (this._seq || 0) + 1;
      const seq = this._seq;
      const infoUrl = this.buildProductViewUrl(nextUrlWithparams, 'quick-view.info');
      const relatedUrl = this.buildProductViewUrl(nextUrlWithparams, 'quick-view.related');
      const infoPromise = fetch(infoUrl).then((r) => r.text());
      const relatedPromise = fetch(relatedUrl).then((r) => r.text());
      Promise.all([infoPromise, relatedPromise])
        .then(([infoHtml, relatedHtml]) => {
          if (!contentDiv || seq !== this._seq) return;
          // Render the info markup
          contentDiv.innerHTML = infoHtml;
          // Inject related markup into its placeholder inside the wrapper
          const target = contentDiv.querySelector('[data-related-target]');
          if (target) {
            this.injectRelatedContent(target, relatedHtml, contentDiv);
          }
          // Re-bind events after DOM replacement
          this.bindVariantRadios(contentDiv);
          this.restoreOptionSelections(contentDiv, rememberedSelections);
          // The focused colour button was replaced, so keep keyboard focus inside the drawer.
          if (!this.contains(document.activeElement)) this.querySelector('.action-close-quick-view')?.focus({ preventScroll: true });
        })
        .catch((error) => {
          console.error('Error loading quick-view info or related:', error);
        });
    }
    getSelectedOptionValues(root) {
      const selections = {};
      if (!root) return selections;

      const selectedInputs = root.querySelectorAll('.pqv__variant-options input[type="radio"]:checked');
      selectedInputs.forEach((input) => {
        if (input.name) {
          selections[input.name] = input.value;
        }
      });

      return selections;
    }
    isSizeOptionName(optionName) {
      return /^(size|größe|grösse)$/i.test(String(optionName || '').trim());
    }
    findBestInputForSelection(root, optionName, selectedValue) {
      const normalize = (value) => String(value || '').trim().toLowerCase();
      const allOptionInputs = Array.from(
        root.querySelectorAll('.pqv__variant-options input[type="radio"]')
      ).filter((input) => input.name === optionName);

      if (!allOptionInputs.length) return null;

      const exactMatchingInput = allOptionInputs.find(
        (input) => normalize(input.value) === normalize(selectedValue) && !input.disabled
      );
      if (exactMatchingInput) return exactMatchingInput;

      if (!this.isSizeOptionName(optionName)) return null;

      const selectedIndex = allOptionInputs.findIndex(
        (input) => normalize(input.value) === normalize(selectedValue)
      );

      if (selectedIndex < 0) {
        return allOptionInputs.find((input) => !input.disabled) || null;
      }

      for (let index = selectedIndex + 1; index < allOptionInputs.length; index += 1) {
        if (!allOptionInputs[index].disabled) return allOptionInputs[index];
      }

      for (let index = selectedIndex - 1; index >= 0; index -= 1) {
        if (!allOptionInputs[index].disabled) return allOptionInputs[index];
      }

      return null;
    }
    restoreOptionSelections(root, selections) {
      if (!root || !selections || Object.keys(selections).length === 0) return;

      const productFormId = root.querySelector('product-form')?.dataset?.productFormId;
      const hiddenInput = productFormId ? root.querySelector(`#${productFormId} input[name="id"]`) : null;

      Object.entries(selections).forEach(([optionName, selectedValue]) => {
        const matchingInput = this.findBestInputForSelection(root, optionName, selectedValue);

        if (!matchingInput) return;

        const matchingLabel = root.querySelector(
          `.pqv__variant-options label[data-variant-id="${matchingInput.dataset.variantId}"]`
        );

        if (matchingLabel) {
          matchingLabel.click();
          return;
        }

        matchingInput.checked = true;
        if (hiddenInput && matchingInput.dataset.variantId) {
          hiddenInput.value = matchingInput.dataset.variantId;
        }
      });
    }
    updateVariantOptionColumns(root) {
      const containers = Array.from(root?.querySelectorAll('.pqv__variant-options') || []);
      const updateColumns = (container) => {
        const labels = Array.from(container.querySelectorAll('label'));
        if (!labels.length) return;

        const hasCompactLabels = labels.every(
          (label) => (label.textContent || '').trim().length <= 4
        );
        const minTileWidth =
          hasCompactLabels && window.matchMedia('(min-width: 990px)').matches ? 44 : 48;
        const styles = window.getComputedStyle(container);
        const gap = Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;
        const paddingLeft = Number.parseFloat(styles.paddingLeft || '0') || 0;
        const paddingRight = Number.parseFloat(styles.paddingRight || '0') || 0;
        const availableWidth = container.clientWidth - paddingLeft - paddingRight;
        const maxColumns = Math.max(
          1,
          Math.floor((availableWidth + gap) / (minTileWidth + gap))
        );

        container.style.setProperty(
          '--variant-option-columns',
          String(Math.min(labels.length, maxColumns))
        );
      };

      this._variantResizeObserver?.disconnect();
      this._variantResizeObserver = new ResizeObserver((entries) => {
        entries.forEach((entry) => updateColumns(entry.target));
      });
      containers.forEach((container) => {
        updateColumns(container);
        this._variantResizeObserver.observe(container);
      });
    }
    bindVariantRadios(root) {
      this.updateVariantOptionColumns(root);
      const productFormId = root.querySelector('product-form')?.dataset?.productFormId;
      const variantRadios = root.querySelectorAll('fieldset .pqv__variant-options label');
      if (variantRadios) {
        variantRadios.forEach((label) => {
          if (label.classList.contains('soldout')) return;
          label.addEventListener('click', (event) => {
            const hiddenInput = document.querySelector(`#${productFormId} input[name="id"]`);
            if (hiddenInput) {
              hiddenInput.value = event.currentTarget.dataset.variantId;
            }
            const variantInput = root.querySelector(
              `input[form="${productFormId}"][data-variant-id="${event.currentTarget.dataset.variantId}"]`
            );
            if (variantInput) {
              variantInput.checked = true;
            }
          });
        });
      }
      // Arrow keys select a size without clicking its label, so keep the cart form in sync on change as well.
      root.querySelectorAll('fieldset .pqv__variant-options input[type="radio"]').forEach((input) => {
        input.addEventListener('change', (event) => {
          // Keep this change away from the product page variant logic, which would rewrite the page URL. A label click never reaches it either.
          event.stopPropagation();
          const hiddenInput = document.querySelector(`#${productFormId} input[name="id"]`);
          if (hiddenInput && input.checked && !input.disabled && input.dataset.variantId) {
            hiddenInput.value = input.dataset.variantId;
          }
        });
      });
    }
    bindRelatedClicks(root) {
      const relatedProducts = root.querySelectorAll('.pqv__related-product');
      if (relatedProducts) {
        relatedProducts.forEach((product) => {
          product.addEventListener('click', (event) => {
            event.preventDefault();
            const nextUrl = product.dataset.variantLink;
            const rememberedSelections = this.getSelectedOptionValues(root);
            if (nextUrl) {
              this.updateActiveRelatedProduct(nextUrl, rememberedSelections);
            }
          });
        });
      }
    }

    injectRelatedContent(target, html, root) {
      target.innerHTML = html;
      target.setAttribute('aria-busy', 'false');

      this.bindRelatedClicks(root);

      // Skeleton overlay logic for images
      const items = target.querySelectorAll('.pqv__related-product');
      items.forEach((item) => {
        const img = item.querySelector('img');
        if (!img) return;

        // Ensure relative positioning so overlay works
        const style = getComputedStyle(item);
        if (style.position === 'static') {
          item.style.position = 'relative';
        }

        if (img.complete) return;

        const overlay = document.createElement('div');
        overlay.className = 'skeleton-block skeleton-overlay';
        overlay.style.position = 'absolute';
        overlay.style.top = '0';
        overlay.style.left = '0';
        overlay.style.width = '100%';
        overlay.style.height = '100%';
        overlay.style.zIndex = '1';
        overlay.style.borderRadius = style.borderRadius || '0px';

        item.appendChild(overlay);

        const removeOverlay = () => {
          overlay.remove();
        };

        img.addEventListener('load', removeOverlay, { once: true });
        img.addEventListener('error', removeOverlay, { once: true });
      });
    }
    openQuickViewDrawer(productUrlRaw) {
      const globalThis = this;
      const contentDiv = this.querySelector('.quick-view-drawer__content');
      // Return focus to the trigger on close, and keep keyboard focus inside the drawer while it is open.
      if (!this.classList.contains('open')) this.opener = document.activeElement;
      this.inert = false;
      this.classList.add('open');
      this.classList.add('loading');
      this.querySelector('.action-close-quick-view').focus({ preventScroll: true });
      document.documentElement.classList.add(`overflow-hidden-all-screens`);

      // Increment request seq to prevent race conditions when switching quickly
      this._seq = (this._seq || 0) + 1;
      const seq = this._seq;

      // Define skeleton parts
      const relatedSkeletonInner = `
            <div class="skeleton-block skeleton-related-title"></div>
            <ul class="pqv__related-products">
              <li class="pqv__related-product skeleton-block"></li>
              <li class="pqv__related-product skeleton-block"></li>
              <li class="pqv__related-product skeleton-block"></li>
              <li class="pqv__related-product skeleton-block"></li>
            </ul>
      `;

      // Insert skeleton immediately to minimize perceived latency
      const skeletonHtml = `
      <div class="pqv-skeleton" aria-busy="true" aria-live="polite">
        <div class="pqv__wrapper">
          <div class="pqv__info pqv-skeleton__info">
            <div class="pqv__image">
              <div class="skeleton-block skeleton-image"></div>
            </div>
            <div class="pqv__body">
              <div class="skeleton-block skeleton-overline"></div>
              <div class="skeleton-block skeleton-title"></div>
              <div class="skeleton-block skeleton-price"></div>
            </div>
          </div>
          <div class="pqv__variants">
            <div class="pqv__form-header">
              <div class="skeleton-block skeleton-variants-label"></div>
            </div>
            <fieldset class="js pqv__form-input pqv__form-input--size">
              <div class="pqv__variant-options">
                <div class="skeleton-block skeleton-variant-chip"></div>
                <div class="skeleton-block skeleton-variant-chip"></div>
                <div class="skeleton-block skeleton-variant-chip"></div>
                <div class="skeleton-block skeleton-variant-chip"></div>
                <div class="skeleton-block skeleton-variant-chip"></div>
              </div>
            </fieldset>
          </div>
          <div class="skeleton-block skeleton-button"></div>
          <div class="pqv__related" data-related-target aria-busy="true">
            ${relatedSkeletonInner}
          </div>
        </div>
      </div>
    `;
      if (contentDiv) contentDiv.innerHTML = skeletonHtml;

      const infoUrl = this.buildProductViewUrl(productUrlRaw, 'quick-view.info');
      const relatedUrl = this.buildProductViewUrl(productUrlRaw, 'quick-view.related');

      let infoRendered = false;
      let relatedHtmlCache = null;

      const infoPromise = fetch(infoUrl).then((r) => r.text());
      const relatedPromise = fetch(relatedUrl).then((r) => r.text());

      infoPromise
        .then((infoHtml) => {
          if (seq !== globalThis._seq) return; // stale
          const cd = globalThis.querySelector('.quick-view-drawer__content');
          if (!cd) return;
          cd.innerHTML = infoHtml;
          infoRendered = true;
          globalThis.classList.remove('loading');

          this.bindVariantRadios(cd);

          // If related not yet loaded, re-inject skeleton to prevent collapse
          if (relatedHtmlCache === null) {
            const target = cd.querySelector('[data-related-target]');
            if (target) {
              target.innerHTML = relatedSkeletonInner;
            }
          }

          // Progressive skeleton overlays to avoid flicker (image -> overline -> title -> price -> button)
          try {
            const removeAfter = (el, delay = 0) => {
              if (!el) return;
              setTimeout(() => {
                el.remove();
              }, delay);
            };
            // Image overlay
            const imageWrap = cd.querySelector('.pqv__image');
            if (imageWrap) {
              const imgOverlay = document.createElement('div');
              imgOverlay.className = 'skeleton-block skeleton-overlay';
              imageWrap.appendChild(imgOverlay);
              const img = imageWrap.querySelector('img');
              if (img && !img.complete) {
                img.addEventListener('load', () => removeAfter(imgOverlay, 0), {
                  once: true,
                });
              } else {
                removeAfter(imgOverlay, 0);
              }
            }
            // Body-relative overlays
            const bodyWrap = cd.querySelector('.pqv__body');
            if (bodyWrap) {
              bodyWrap.classList.add('pqv__body--relative');
              const makeInlineOverlay = (targetEl) => {
                if (!targetEl) return null;
                const rectTop = targetEl.offsetTop;
                const rectHeight = targetEl.offsetHeight || 18;
                const rectWidth = targetEl.offsetWidth || '100%';
                const ov = document.createElement('div');
                ov.className = 'skeleton-block skeleton-overlay';
                ov.style.top = rectTop + 'px';
                ov.style.height = rectHeight + 'px';
                if (typeof rectWidth === 'number') ov.style.width = rectWidth + 'px';
                return ov;
              };
              const overlineEl = bodyWrap.querySelector('.pqv__overline');
              const titleEl = bodyWrap.querySelector('.pqv__title');
              const priceEl = bodyWrap.querySelector(".price, .price__container, [class*='price']") || null;
              const overlineOv = makeInlineOverlay(overlineEl);
              const titleOv = makeInlineOverlay(titleEl);
              const priceOv = makeInlineOverlay(priceEl);
              if (overlineOv) bodyWrap.appendChild(overlineOv);
              if (titleOv) bodyWrap.appendChild(titleOv);
              if (priceOv) bodyWrap.appendChild(priceOv);
              removeAfter(overlineOv, 50);
              removeAfter(titleOv, 100);
              removeAfter(priceOv, 150);
            }
            // Button overlay
            const btn = cd.querySelector('button.product-form__submit,[name="add"]');
            if (btn) {
              const btnWrap = btn.parentElement || btn;
              btnWrap.style.position = btnWrap.style.position || 'relative';
              const btnOv = document.createElement('div');
              btnOv.className = 'skeleton-block skeleton-overlay';
              btnOv.style.height = btn.offsetHeight ? btn.offsetHeight + 'px' : '44px';
              btnOv.style.borderRadius = getComputedStyle(btn).borderRadius || '6px';
              btnWrap.appendChild(btnOv);
              removeAfter(btnOv, 200);
            }
          } catch (e) {
            console.warn('Progressive reveal overlay failed', e);
          }

          // If related already fetched, inject it now
          if (relatedHtmlCache !== null) {
            const target = cd.querySelector('[data-related-target]');
            if (target) {
              this.injectRelatedContent(target, relatedHtmlCache, cd);
            }
          }
        })
        .catch((error) => {
          console.error('Error loading quick-view info:', error);
        });

      relatedPromise
        .then((relatedHtml) => {
          if (seq !== globalThis._seq) return; // stale
          relatedHtmlCache = relatedHtml;
          if (!infoRendered) return;
          const cd = globalThis.querySelector('.quick-view-drawer__content');
          if (!cd) return;
          const target = cd.querySelector('[data-related-target]');
          if (target) {
            this.injectRelatedContent(target, relatedHtml, cd);
          }

          let sizeChartTabs = document.querySelectorAll('.size-tabs__wrapper .size-tab-title');
          if (sizeChartTabs) {
            sizeChartTabs.forEach((tab) => {
              tab.addEventListener('click', function () {
                let sizeChartTabs = document.querySelectorAll('.size-tabs__wrapper .size-tab-title'),
                  sizeGuideTables = document.querySelectorAll('.size-guide__table');

                sizeChartTabs.forEach((tab) => {
                  if (tab.classList.contains('is-active')) {
                    tab.classList.remove('is-active');
                  }
                });
                sizeGuideTables.forEach((table) => (table.style.display = 'none'));
                if (!tab.classList.contains('is-active')) {
                  tab.classList.add('is-active');
                }
                document.getElementById(tab.dataset.id).style.display = 'flex';
              });
            });
          }
        })

        .catch((error) => {
          console.error('Error loading quick-view related:', error);
        });
    }
    closeQuickViewDrawer() {
      if (!this.classList.contains('open')) return;
      this.querySelectorAll('modal-dialog[open]').forEach((modal) => modal.hide());
      this.classList.remove('open');
      this.inert = true;
      if (this.contains(document.activeElement) && this.opener?.isConnected) this.opener.focus({ preventScroll: true });
      this.opener = null;
      if (!document.querySelector('cart-drawer details[open]')) {
        document.documentElement.classList.remove(`overflow-hidden-all-screens`);
      }
      // document.documentElement.classList.remove(`overflow-hidden`);
      // document.body.classList.remove(`overflow-hidden`);
      this.classList.add('loading');
    }
  }
  customElements.define('quick-view-drawer', QuickViewDrawer);
  } catch(e) { console.error(e); }
})();

})();
